'use strict';
const csTheme = JSON.parse(document.getElementById('cs-theme-data').textContent);
const themeAsset = name => /^(https?:)?\/\//.test(String(name)) ? name : csTheme.assets[String(name).replace(/^assets\//, '')] || csTheme.assets['horizonlite-product.jpg'];
function nativeRatingFallback(product, url) {
  const rating = Math.max(0,Math.min(5,Number(product.rating)||0)), raters = Math.max(0,Number(product.raters)||0);
  if (!raters) return `<a class="c-reviews-placeholder" href="${escapeHtml(url)}#product-reviews"><span class="c-review-stars" aria-hidden="true">☆☆☆☆☆</span><span>Reviews</span></a>`;
  return `<a class="c-reviews-placeholder" href="${escapeHtml(url)}#product-reviews" aria-label="Rated ${rating.toFixed(1)} out of 5 from ${raters} reviews"><span class="c-native-stars" aria-hidden="true"><span>★★★★★</span><span style="width:${rating/5*100}%">★★★★★</span></span><span>${rating.toFixed(1)} (${raters})</span></a>`;
}
function mergeNativeProjects(registry) {
  if (!csTheme.articles?.length) return;
  const known = Object.entries(registry);
  const merged = {};
  csTheme.articles.forEach(article => {
    const match = known.find(([, p]) => new URL(p.url, window.location.origin).pathname === article.url);
    const key = match?.[0] || article.url.split('/').pop();
    merged[key] = match ? { ...match[1], url: article.url } : {
      title: article.title, url: article.url, summary: article.excerpt, paragraphs: [article.excerpt],
      image: article.image || 'project-single.jpg', imageAlt: article.title,
      category: 'REAL PROJECT', credit: 'Cambridge Skylights project collection', details: [], sizes: [], kind: 'other'
    };
  });
  Object.keys(registry).forEach(key => delete registry[key]);
  Object.assign(registry, merged);
}


// responsive-images:start
const responsiveImages = {"gallery-thumb-after-dark-daylight.jpg":[165,220,[165]],"gallery-thumb-after-dark.jpg":[220,220,[220]],"gallery-thumb-contemporary.jpg":[124,220,[124]],"gallery-thumb-earlsfield-kitchen.jpg":[220,147,[220]],"gallery-thumb-earlsfield.jpg":[220,147,[220]],"gallery-thumb-heart-doorway.jpg":[165,220,[165]],"gallery-thumb-heart-home.jpg":[165,220,[165]],"gallery-thumb-kitchen-detail.jpg":[165,220,[165]],"gallery-thumb-kitchen-dining.jpg":[165,220,[165]],"gallery-thumb-kitchen-table.jpg":[165,220,[165]],"gallery-thumb-loft-bedroom.jpg":[147,220,[147]],"gallery-thumb-loft.jpg":[147,220,[147]],"gallery-thumb-long-extension.jpg":[165,220,[165]],"gallery-thumb-low-ceiling.jpg":[165,220,[165]],"gallery-thumb-maida-vale.jpg":[220,147,[220]],"gallery-thumb-morning.jpg":[147,220,[147]],"gallery-thumb-north-facing.jpg":[220,165,[220]],"gallery-thumb-reimagined.jpg":[220,165,[220]],"gallery-thumb-roof-installation.jpg":[220,220,[220]],"gallery-thumb-side-return.jpg":[220,166,[220]],"gallery-thumb-single-sky.jpg":[165,220,[165]],"gallery-thumb-single.jpg":[220,165,[220]],"heart-detail.jpg":[1600,2133,[160,320,480,768,1024,1440,1600]],"heart-dining.jpg":[1600,2133,[160,320,480,768,1024,1440,1600]],"heart-home.jpg":[1200,1200,[160,320,480,768,1024,1200]],"hero-earlsfield.jpg":[1600,1066,[160,320,480,768,1024,1440,1600]],"horizonlite-product.jpg":[1200,1200,[160,320,480,768,1024,1200]],"installation-after-dark-03.jpg":[1500,2000,[160,320,480,768,1024,1440,1500]],"installation-after-dark-04.jpg":[1600,1600,[160,320,480,768,1024,1440,1600]],"installation-after-dark-06.jpg":[1600,1600,[160,320,480,768,1024,1440,1600]],"installation-contemporary-04.jpg":[1127,2000,[160,320,480,768,1024,1127]],"installation-earlsfield-02.jpg":[1600,1066,[160,320,480,768,1024,1440,1600]],"installation-earlsfield-03.jpg":[1600,1066,[160,320,480,768,1024,1440,1600]],"installation-heart-01.jpg":[1500,2000,[160,320,480,768,1024,1440,1500]],"installation-heart-02.jpg":[1500,2000,[160,320,480,768,1024,1440,1500]],"installation-kitchen-02.jpg":[1500,2000,[160,320,480,768,1024,1440,1500]],"installation-kitchen-04.jpg":[1500,2000,[160,320,480,768,1024,1440,1500]],"installation-loft-02.jpg":[1333,2000,[160,320,480,768,1024,1333]],"installation-loft-04.jpg":[1333,2000,[160,320,480,768,1024,1333]],"installation-long-extension-02.jpg":[1500,2000,[160,320,480,768,1024,1440,1500]],"installation-maida-vale-01.jpg":[1600,1067,[160,320,480,768,1024,1440,1600]],"installation-morning-02.jpg":[709,1063,[160,320,480,709]],"installation-north-facing-02.jpg":[1600,1200,[160,320,480,768,1024,1440,1600]],"installation-side-return-02.jpg":[1600,1205,[160,320,480,768,1024,1440,1600]],"installation-single-01.jpg":[1600,1200,[160,320,480,768,1024,1440,1600]],"installation-single-05.jpg":[1500,2000,[160,320,480,768,1024,1440,1500]],"kitchen-daylight.jpg":[1600,2133,[160,320,480,768,1024,1440,1600]],"kitchen-detail.jpg":[1350,1800,[160,320,480,768,1024,1350]],"kitchen-extension.jpg":[1350,1800,[160,320,480,768,1024,1350]],"kitchen-view.jpg":[1600,2133,[160,320,480,768,1024,1440,1600]],"mansard-loft.jpg":[1200,1800,[160,320,480,768,1024,1200]],"morning-light.jpg":[709,1063,[160,320,480,709]],"percenta-coating.png":[480,480,[160,320,480]],"project-after-dark.jpg":[1400,1400,[160,320,480,768,1024,1400]],"project-contemporary.jpg":[789,1400,[160,320,480,768,789]],"project-long-extension.jpg":[1050,1400,[160,320,480,768,1024,1050]],"project-low-ceiling.jpg":[1050,1400,[160,320,480,768,1024,1050]],"project-maida-vale.jpg":[1400,1050,[160,320,480,768,1024,1400]],"project-north-facing.jpg":[1050,1400,[160,320,480,768,1024,1050]],"project-reimagined.jpg":[1400,1050,[160,320,480,768,1024,1400]],"project-side-return.jpg":[1400,1054,[160,320,480,768,1024,1400]],"project-single.jpg":[1400,1050,[160,320,480,768,1024,1400]],"roof-installation-flat-evening.jpg":[1600,720,[160,320,480,768,1024,1440,1600]],"roof-installation-flat-light.jpg":[1600,1200,[160,320,480,768,1024,1440,1600]],"roof-installation-flat-tiles.jpg":[1600,1200,[160,320,480,768,1024,1440,1600]],"roof-installation-pitched-metal.jpg":[1600,901,[160,320,480,768,1024,1440,1600]],"roof-installation-pitched-tiles.jpg":[1600,1200,[160,320,480,768,1024,1440,1600]],"roof-installation-red-tiles.jpg":[1600,1200,[160,320,480,768,1024,1440,1600]],"structural-tape.png":[480,480,[160,320,480]],"horizonlite-roof-installation.png":[1200,1200,[160,320,480,768,1024,1200]],"roof-installation-garden-extension.png":[709,1063,[160,320,480,709]]};
function responsiveAsset(filename) { return themeAsset(filename); }
function responsiveImageData(filename, sizes = '(max-width: 700px) calc(100vw - 48px), 50vw') {
  const record = responsiveImages[filename];
  if (!record) return {src: filename, srcset: '', sizes};
  const [width,height,widths] = record;
  const stem = filename.replace(/\.[^.]+$/, '');
  const variant = w => responsiveAsset(`${stem}--w${w}.webp`);
  return {src:variant(widths.find(w=>w>=768)||widths[widths.length-1]),srcset:widths.map(w=>`${variant(w)} ${w}w`).join(', '),sizes,width,height};
}
function responsiveImageAttributes(filename, sizes) {
  const image = responsiveImageData(filename, sizes);
  return `src="${escapeHtml(image.src)}"${image.srcset ? ` srcset="${escapeHtml(image.srcset)}" sizes="${escapeHtml(image.sizes)}"` : ''} decoding="async"`;
}
function setResponsiveImage(element, filename, sizes) {
  const image = responsiveImageData(filename, sizes);
  element.sizes = image.sizes;
  element.srcset = image.srcset;
  element.src = image.src;
}

// responsive-images:end

const $ = (selector, scope = document) => scope.querySelector(selector);
const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
const formatPrice = value => new Intl.NumberFormat('en-GB', { style: 'currency', currency: csTheme.currency, maximumFractionDigits: Number.isInteger(value) ? 0 : 2 }).format(value);
const escapeHtml = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

const projects = {
  "single": {
    "title": "One rooflight. A brighter kitchen.",
    "category": "KITCHEN EXTENSION",
    "image": "project-single.jpg",
    "credit": "From the Cambridge Skylights project collection",
    "paragraphs": [
      "A full renovation brought several smaller rooms together into one open kitchen. The roof glazing became an important part of the new space, with a single larger rooflight chosen during the planning process.",
      "The finished project uses a 1000 × 3000 mm Cambridge fixed frameless rooflight. Explore the ceiling detail, the view from inside and the completed kitchen in the full project story."
    ],
    "details": [
      [
        "Project",
        "Kitchen Extension"
      ],
      [
        "Rooflights",
        "Cambridge fixed frameless rooflights"
      ],
      [
        "Size",
        "1000 × 3000 mm"
      ]
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/choosing-one-frameless-rooflight-over-three-velux-windows",
    "summary": "A single 1000 × 3000 mm rooflight becomes part of an open kitchen renovation.",
    "productWidth": 1000,
    "productLength": 3000,
    "kind": "kitchen",
    "sizes": [
      [
        1000,
        3000
      ]
    ],
    "sourceTitle": "Choosing One Frameless Rooflight Over Three Velux Windows",
    "imageAlt": "A single frameless rooflight in a completed kitchen renovation"
  },
  "morning": {
    "title": "A brighter start to the day.",
    "category": "KITCHEN EXTENSION",
    "image": "morning-light.jpg",
    "credit": "Project & photography: Annie · @glenhurst_house",
    "size": "1000 × 1200 mm",
    "productWidth": 1000,
    "productLength": 1200,
    "details": [
      [
        "Project",
        "East-facing kitchen extension"
      ],
      [
        "Rooflight",
        "Cambridge HorizonLite"
      ],
      [
        "Size",
        "1000 × 1200 mm"
      ]
    ],
    "paragraphs": [
      "This rear kitchen extension faces east. As the room grew, the homeowners wanted to make the most of the morning sunlight and bring daylight into the centre of the new space.",
      "A 1000 × 1200 mm Cambridge HorizonLite rooflight was chosen for its fixed frameless design. Light now enters from above as well as through the garden glazing, with a clear view of the sky from inside.",
      "Explore the finished kitchen and the details of this project in Annie’s home."
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/morning-light-over-an-east-facing-kitchen-extension",
    "summary": "An east-facing kitchen makes the most of its morning light.",
    "kind": "kitchen",
    "sizes": [
      [
        1000,
        1200
      ]
    ],
    "sourceTitle": "Morning Light Over an East-Facing Kitchen Extension",
    "imageAlt": "Morning Light Over an East-Facing Kitchen Extension"
  },
  "kitchen": {
    "title": "Daylight, all the way through.",
    "category": "KITCHEN EXTENSION",
    "image": "kitchen-extension.jpg",
    "credit": "In collaboration with LT Building Services Ltd.",
    "size": "800 × 2000 mm",
    "productWidth": 800,
    "productLength": 2000,
    "details": [
      [
        "Project",
        "5 m × 8.5 m kitchen extension"
      ],
      [
        "Rooflights",
        "Two Cambridge HorizonLite units"
      ],
      [
        "Size",
        "800 × 2000 mm"
      ]
    ],
    "paragraphs": [
      "A large kitchen extension needed daylight in the middle of the room as well as beside the garden doors. Two fixed frameless HorizonLite rooflights were positioned to bring light from above into the kitchen and dining space.",
      "The project also includes an adjoining playroom without its own external window. The overhead light helps this part of the extension feel connected to the main living space.",
      "See the completed rooms and the rooflight details in the full project story."
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/natural-light-transforming-a-kitchen-extension",
    "summary": "Two HorizonLite rooflights bring daylight into the centre of a generous extension.",
    "kind": "kitchen",
    "sizes": [
      [
        800,
        2000
      ]
    ],
    "sourceTitle": "Natural Light Transforming a Kitchen Extension",
    "imageAlt": "Natural Light Transforming a Kitchen Extension"
  },
  "earlsfield": {
    "title": "Room for everyone. Light for every corner.",
    "category": "EARLSFIELD, LONDON",
    "image": "hero-earlsfield.jpg",
    "credit": "In collaboration with Ash Island Lofts",
    "details": [
      [
        "Location",
        "Earlsfield, South West London"
      ],
      [
        "Project",
        "Family kitchen and dining space"
      ],
      [
        "Rooflights",
        "Cambridge fixed frameless rooflights"
      ]
    ],
    "paragraphs": [
      "In this London terrace, a series of fixed frameless rooflights brings daylight across the kitchen and dining space. Garden doors provide light from the rear; overhead glazing reaches further into the room.",
      "The rooflights are set along the ceiling above pale cabinetry and timber flooring. Their frameless appearance keeps the view of the sky clear and the ceiling detailing simple.",
      "Discover the complete project created with Ash Island Lofts."
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/layered-daylight-in-earlsfield",
    "summary": "A series of rooflights brings balanced daylight across a family kitchen.",
    "kind": "kitchen",
    "sizes": [],
    "sourceTitle": "Layered Daylight in Earlsfield",
    "imageAlt": "Layered Daylight in Earlsfield"
  },
  "heart": {
    "title": "A rooflight at the heart of the home.",
    "category": "HOME EXTENSION",
    "image": "heart-home.jpg",
    "credit": "Project & photography: Rebecca James · @homeonthetrees",
    "paragraphs": [
      "A rooflight was part of this home extension from the earliest plans. The homeowners chose a flat frameless design to keep the ceiling simple and make the view of the sky part of the room.",
      "A 1000 × 3000 mm HorizonLite rooflight brings daylight into the space. Discover the finished extension and the details of Rebecca’s project."
    ],
    "details": [
      [
        "Project",
        "Home Extension"
      ],
      [
        "Rooflights",
        "Cambridge fixed frameless rooflights"
      ],
      [
        "Size",
        "1000 × 3000 mm"
      ]
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/a-frameless-rooflight-that-became-the-heart-of-the-home",
    "summary": "A 1000 × 3000 mm rooflight frames the sky in a carefully planned home extension.",
    "productWidth": 1000,
    "productLength": 3000,
    "kind": "kitchen",
    "sizes": [
      [
        1000,
        3000
      ]
    ],
    "sourceTitle": "A Frameless Rooflight that Became the Heart of the Home",
    "imageAlt": "A Frameless Rooflight that Became the Heart of the Home"
  },
  "after-dark": {
    "title": "From daylight to after dark.",
    "category": "KITCHEN EXTENSION",
    "image": "project-after-dark.jpg",
    "credit": "Project & photography: Christian",
    "paragraphs": [
      "For this single-storey rear extension, daylight was part of the plan from the beginning. Fixed frameless rooflights bring light from above into the kitchen and dining space, with a view of the changing sky from inside.",
      "The project uses 800 × 1800 mm and 800 × 1000 mm rooflights. Explore Christian’s completed space and photographs in the full project story."
    ],
    "details": [
      [
        "Project",
        "Kitchen Extension"
      ],
      [
        "Rooflights",
        "Cambridge fixed frameless rooflights"
      ],
      [
        "Sizes",
        "800 × 1800 mm · 800 × 1000 mm"
      ]
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/from-daylight-to-after-dark-a-frameless-rooflight-feature",
    "summary": "Two rooflight sizes bring daylight and sky views into an open-plan kitchen and dining space.",
    "productWidth": 800,
    "productLength": 1800,
    "kind": "kitchen",
    "sizes": [
      [
        800,
        1800
      ],
      [
        800,
        1000
      ]
    ],
    "sourceTitle": "From Daylight to After Dark: A Frameless Rooflight Feature",
    "imageAlt": "From Daylight to After Dark: A Frameless Rooflight Feature"
  },
  "loft": {
    "title": "A new view from the loft.",
    "category": "LOFT CONVERSION",
    "image": "mansard-loft.jpg",
    "credit": "Project & photography: Philip & Claudine Blythman · @e5locationhouse",
    "productWidth": 1200,
    "productLength": 1200,
    "details": [
      [
        "Project",
        "Mansard loft conversion"
      ],
      [
        "Rooflights",
        "Two Cambridge HorizonLite units"
      ],
      [
        "Sizes",
        "1200 × 1200 mm and 800 × 1000 mm"
      ]
    ],
    "paragraphs": [
      "Two rooflights bring daylight into this new loft level: one above the stairwell, the other over a compact kitchenette. The homeowners wanted these internal spaces to feel open and connected to the sky.",
      "The fixed frameless design gives each opening a simple finish. LED strip lighting in the plasterboard reveals adds another detail to the space after dark.",
      "Explore the completed conversion in Philip and Claudine’s full project story."
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/frameless-rooflights-transform-a-mansard-loft-conversion",
    "summary": "Two rooflights bring daylight into a stairwell and kitchenette in a mansard loft conversion.",
    "kind": "loft",
    "sizes": [
      [
        1200,
        1200
      ],
      [
        800,
        1000
      ]
    ],
    "sourceTitle": "Frameless Rooflights Transform a Mansard Loft Conversion",
    "imageAlt": "Frameless Rooflights Transform a Mansard Loft Conversion"
  },
  "side-return": {
    "title": "Light where it matters most.",
    "category": "KITCHEN EXTENSION",
    "image": "project-side-return.jpg",
    "credit": "From the Cambridge Skylights project collection",
    "paragraphs": [
      "A side-return kitchen extension reclaimed unused space and introduced an adjoining internal room. Roof glazing was important for bringing daylight into the parts of the plan that could not rely on garden windows alone.",
      "The project uses an 800 × 1500 mm fixed frameless rooflight. Timber detailing around the opening connects it with the other wooden elements in the room."
    ],
    "details": [
      [
        "Project",
        "Kitchen Extension"
      ],
      [
        "Rooflights",
        "Cambridge fixed frameless rooflights"
      ],
      [
        "Size",
        "800 × 1500 mm"
      ]
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/light-where-it-matters-most",
    "summary": "An 800 × 1500 mm rooflight helps a side-return extension feel connected and bright.",
    "productWidth": 800,
    "productLength": 1500,
    "kind": "kitchen",
    "sizes": [
      [
        800,
        1500
      ]
    ],
    "sourceTitle": "Light Where It Matters Most",
    "imageAlt": "Light Where It Matters Most"
  },
  "maida-vale": {
    "title": "Sky and space in a Maida Vale loft.",
    "category": "LOFT CONVERSION",
    "image": "project-maida-vale.jpg",
    "credit": "In collaboration with Ash Island Lofts",
    "paragraphs": [
      "This Maida Vale loft conversion creates a new living space above a London terrace. A fixed frameless rooflight sits between solar panels and brings daylight into the room below.",
      "Glazing onto the roof terrace connects the loft with the skyline. Explore the completed project created with Ash Island Lofts."
    ],
    "details": [
      [
        "Project",
        "Loft Conversion"
      ],
      [
        "Rooflights",
        "Cambridge fixed frameless rooflights"
      ]
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/bringing-sky-and-space-to-a-queens-park-loft",
    "summary": "A fixed frameless rooflight brings overhead daylight into a London loft conversion.",
    "kind": "loft",
    "sizes": [],
    "sourceTitle": "Bringing Sky and Space to a Maida Vale Loft",
    "imageAlt": "Bringing Sky and Space to a Maida Vale Loft"
  },
  "contemporary": {
    "title": "Twelve rooflights. One considered build.",
    "category": "CONTEMPORARY BUILD",
    "image": "project-contemporary.jpg",
    "credit": "In collaboration with Lodgico Ltd.",
    "paragraphs": [
      "This contemporary build uses twelve Cambridge rooflights: ten on the main house and two on the garage. The project called for a consistent frameless finish across the roofscape.",
      "Corrugated roof sheets formed part of the construction. Explore the completed installation, roof detailing and project photographs from Lodgico Ltd."
    ],
    "details": [
      [
        "Project",
        "Contemporary Build"
      ],
      [
        "Rooflights",
        "Cambridge fixed frameless rooflights"
      ],
      [
        "Units",
        "Twelve: ten on the house and two on the garage"
      ]
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/twelve-frameless-rooflights-across-a-contemporary-build",
    "summary": "Twelve fixed frameless rooflights across a contemporary house and garage.",
    "kind": "other",
    "sizes": [],
    "sourceTitle": "Twelve Frameless Rooflights Across a Contemporary Build",
    "imageAlt": "Twelve Frameless Rooflights Across a Contemporary Build"
  },
  "long-extension": {
    "title": "Daylight through a long extension.",
    "category": "KITCHEN EXTENSION",
    "image": "project-long-extension.jpg",
    "credit": "Project feature: @thebigger_house",
    "paragraphs": [
      "A long, relatively narrow extension needed daylight beyond the garden end of the room. Roof glazing was included in the plans to bring overhead light into the north-facing space.",
      "The project uses 800 × 1000 mm fixed frameless rooflights. Explore the completed extension and the ceiling detailing in the full story from @thebigger_house."
    ],
    "details": [
      [
        "Project",
        "Kitchen Extension"
      ],
      [
        "Rooflights",
        "Cambridge fixed frameless rooflights"
      ],
      [
        "Size",
        "800 × 1000 mm"
      ]
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/turning-a-long-extension-into-a-light-filled-space",
    "summary": "An 800 × 1000 mm rooflight helps bring daylight into a long north-facing extension.",
    "productWidth": 800,
    "productLength": 1000,
    "kind": "kitchen",
    "sizes": [
      [
        800,
        1000
      ]
    ],
    "sourceTitle": "Turning a Long Extension into a Light-Filled Space",
    "imageAlt": "Turning a Long Extension into a Light-Filled Space"
  },
  "low-ceiling": {
    "title": "A brighter low-ceiling extension.",
    "category": "KITCHEN EXTENSION",
    "image": "project-low-ceiling.jpg",
    "credit": "Project & photography: Lisa Peace",
    "paragraphs": [
      "This compact extension had a low ceiling and limited natural light. Roof glazing offered a way to bring daylight into the kitchen and dining space without changing the footprint.",
      "The project uses 800 × 1500 mm fixed rooflights. Explore Lisa’s completed extension and see how the glazing sits within the ceiling."
    ],
    "details": [
      [
        "Project",
        "Kitchen Extension"
      ],
      [
        "Rooflights",
        "Cambridge fixed frameless rooflights"
      ],
      [
        "Size",
        "800 × 1500 mm"
      ]
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/bringing-sunshine-into-a-low-ceiling-extension",
    "summary": "Overhead daylight lifts a compact kitchen and dining extension.",
    "productWidth": 800,
    "productLength": 1500,
    "kind": "kitchen",
    "sizes": [
      [
        800,
        1500
      ]
    ],
    "sourceTitle": "Bringing Sunshine into a Low-Ceiling Extension",
    "imageAlt": "Bringing Sunshine into a Low-Ceiling Extension"
  },
  "north-facing": {
    "title": "A north-facing kitchen, brought to light.",
    "category": "KITCHEN EXTENSION",
    "image": "project-north-facing.jpg",
    "credit": "Project & photography: Phil Ternent",
    "paragraphs": [
      "Most of this kitchen diner extension’s roof faces north. The project was designed to introduce generous, diffused daylight from above into the new living space.",
      "Opening sash windows already provided ventilation, so a fixed frameless rooflight suited the plans. Explore Phil’s project and the 1200 × 1800 mm HorizonLite size used."
    ],
    "details": [
      [
        "Project",
        "Kitchen Extension"
      ],
      [
        "Rooflights",
        "Cambridge fixed frameless rooflights"
      ],
      [
        "Size",
        "1200 × 1800 mm"
      ]
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/transforming-a-north-facing-kitchen-with-indirect-light",
    "summary": "A 1200 × 1800 mm rooflight brings overhead daylight into a kitchen diner.",
    "productWidth": 1200,
    "productLength": 1800,
    "kind": "kitchen",
    "sizes": [
      [
        1200,
        1800
      ]
    ],
    "sourceTitle": "Transforming a North-Facing Kitchen with Indirect Light",
    "imageAlt": "Transforming a North-Facing Kitchen with Indirect Light"
  },
  "reimagined": {
    "title": "A kitchen reimagined through light.",
    "category": "KITCHEN EXTENSION",
    "image": "project-reimagined.jpg",
    "credit": "From the Cambridge Skylights project collection",
    "paragraphs": [
      "Inspired by renovation programmes, the homeowners wanted to bring light into a kitchen that relied on windows in one direction. Overhead glazing became the next step in the plans.",
      "A 1000 × 1200 mm HorizonLite rooflight was chosen for a simple fixed frameless finish. Explore the completed room and the view from inside."
    ],
    "details": [
      [
        "Project",
        "Kitchen Extension"
      ],
      [
        "Rooflights",
        "Cambridge fixed frameless rooflights"
      ],
      [
        "Size",
        "1000 × 1200 mm"
      ]
    ],
    "url": "https://cambridgeskylights.co.uk/blogs/case-studies/a-kitchen-reimagined-through-light-1",
    "summary": "A 1000 × 1200 mm rooflight gives a traditional kitchen a new view of the sky.",
    "productWidth": 1000,
    "productLength": 1200,
    "kind": "kitchen",
    "sizes": [
      [
        1000,
        1200
      ]
    ],
    "sourceTitle": "A Kitchen Reimagined Through Light",
    "imageAlt": "A Kitchen Reimagined Through Light"
  }
};

mergeNativeProjects(projects);

let products = [];
let horizonliteAddons = [];
let catalogueLoadState = 'loading';
let expanded = false;

const standardVatRate = csTheme.vatRate;
const priceDisplayStorageKey = 'cambridge-skylights-price-display';
function initialPriceDisplay() {
  const requested = new URLSearchParams(window.location.search).get('vat');
  if (requested === 'incl' || requested === 'excl') return requested;
  try { return sessionStorage.getItem(priceDisplayStorageKey) === 'excl' ? 'excl' : 'incl'; }
  catch { return 'incl'; }
}
let priceDisplayMode = initialPriceDisplay();

// Store prices remain VAT-inclusive. Only the displayed amount changes.
function priceInMode(inclusivePrice, mode = priceDisplayMode) {
  const pence = Math.round(Number(inclusivePrice) * 100);
  return (mode === 'excl' ? Math.round(pence / (1 + standardVatRate)) : pence) / 100;
}
function displayPrice(inclusivePrice, mode = priceDisplayMode) { return formatPrice(priceInMode(inclusivePrice, mode)); }
function priceVatLabel(mode = priceDisplayMode) { return mode === 'excl' ? 'excl. VAT' : 'incl. VAT'; }
function priceMarkup(inclusivePrice, mode = priceDisplayMode) {
  return `${displayPrice(inclusivePrice, mode)} <span class="price-vat-label">${priceVatLabel(mode)}</span>`;
}
function isOnSale(product) {
  return Number.isFinite(Number(product?.comparePrice)) && Math.round(Number(product.comparePrice) * 100) > Math.round(Number(product.price) * 100);
}
function saleBadgeMarkup(product) { return isOnSale(product) ? '<span class="sale-badge">Sale</span>' : ''; }
function displayedPricePairMarkup(current, original, mode, showSaving = false) {
  const now = `${formatPrice(current)} <span class="price-vat-label">${priceVatLabel(mode)}</span>`;
  if (Math.round(original * 100) <= Math.round(current * 100)) return now;
  const saving = Math.round((original - current) * 100) / 100;
  return `<span class="sale-prices"><s class="price-was"><span class="visually-hidden">Was </span>${formatPrice(original)}</s><span class="price-now"><span class="visually-hidden">Now </span>${now}</span>${showSaving ? `<span class="price-saving">Save ${formatPrice(saving)}</span>` : ''}</span>`;
}
function productPriceMarkup(product, quantity = 1, mode = priceDisplayMode, showSaving = false) {
  const original = isOnSale(product) ? product.comparePrice : product.price;
  return displayedPricePairMarkup(priceInMode(product.price * quantity, mode), priceInMode(original * quantity, mode), mode, showSaving);
}
function orderPriceMarkup(items, mode = priceDisplayMode) {
  const current = basketTotals(items);
  const original = basketTotals(items.map(({ product, quantity }) => ({ product: { ...product, price: isOnSale(product) ? product.comparePrice : product.price }, quantity })));
  const key = mode === 'excl' ? 'exclusivePence' : 'inclusivePence';
  return displayedPricePairMarkup(current[key] / 100, original[key] / 100, mode);
}
function syncPriceControls() {
  $$('[data-vat-mode]').forEach(button => {
    const active = button.dataset.vatMode === priceDisplayMode;
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', String(active));
  });
  $$('[data-vat-label]').forEach(label => { label.textContent = priceVatLabel(); });
}
function updateVatUrl(url) {
  if (priceDisplayMode === 'excl') url.searchParams.set('vat', 'excl');
  else url.searchParams.delete('vat');
}
function setPriceDisplay(mode) {
  if (!['incl', 'excl'].includes(mode) || mode === priceDisplayMode) return;
  priceDisplayMode = mode;
  try { sessionStorage.setItem(priceDisplayStorageKey, mode); } catch { /* Keep the selection in memory. */ }
  const url = new URL(window.location.href);
  updateVatUrl(url);
  window.history.replaceState(null, '', url);
  syncPriceControls();
  if ($('#size-form') && products.length) renderProducts();
  document.dispatchEvent(new CustomEvent('prices:changed'));
}
function stockStatus(product) {
  return ['in-stock', 'pre-order'].includes(product.stockStatus) ? product.stockStatus : 'unknown';
}
function stockLabel(product) {
  const status = stockStatus(product);
  return status === 'in-stock' ? 'In stock — ready for dispatch' : status === 'pre-order' ? 'Pre-order — back in stock in 2–3 weeks. Save 10% with PRE10' : 'Ask our team about stock';
}
function rooflightUrl(product) { const u = new URL(product.url, window.location.origin); if (priceDisplayMode === 'excl') u.searchParams.set('vat','excl'); return u.pathname + u.search; }
document.addEventListener('click', event => {
  const button = event.target.closest('[data-vat-mode]');
  if (button) setPriceDisplay(button.dataset.vatMode);
});
syncPriceControls();

// The two dimensions describe an opening; their order never selects a different rooflight.
function sizeKey(product) {
  return [product.width, product.length].sort((a, b) => a - b).join('x');
}

function parseSizeKey(value) {
  const match = String(value || '').trim().match(/^(\d+)\s*[x×]\s*(\d+)\s*(?:mm)?$/i);
  return match ? [Number(match[1]), Number(match[2])].sort((a, b) => a - b).join('x') : '';
}

function sizeLabel(product) {
  return sizeKey(product).replace('x', ' × ') + ' mm';
}

// Shopify's cart is the source of truth. No preview basket or saved product prices are used.
let nativeCart = null;
const nativeCartEndpoint = suffix => `${csTheme.root.replace(/\/$/,'')}/cart${suffix}.js`;
async function nativeCartRequest(suffix, body) {
  const response = await fetch(nativeCartEndpoint(suffix), {
    method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
    headers: { Accept: 'application/json', ...(body ? {'Content-Type':'application/json'} : {}) },
    ...(body ? { body: JSON.stringify(body) } : {})
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.description || data.message || 'Your cart could not be updated. Please try again.');
  return data;
}
function setNativeCart(cart) {
  nativeCart = cart;
  $$('[data-cart-count]').forEach(node => { node.textContent = String(cart.item_count); });
  $$('[data-cart-link]').forEach(link => link.setAttribute('aria-label', `Cart, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`));
  document.dispatchEvent(new CustomEvent('cart:changed', { detail: cart }));
}
async function refreshNativeCart() { const cart = await nativeCartRequest(''); setNativeCart(cart); return cart; }
async function addNativeCartItems(items) {
  try { await nativeCartRequest('/add', { items }); }
  catch (error) { await refreshNativeCart().catch(() => {}); throw error; }
  return refreshNativeCart();
}
async function changeNativeCartItem(key, quantity) { const cart = await nativeCartRequest('/change', { id: key, quantity }); setNativeCart(cart); return cart; }
function basketTotals(items) {
  const inclusivePence = items.reduce((sum, item) => sum + Math.round(item.product.price * 100) * item.quantity, 0);
  const exclusivePence = items.reduce((sum, item) => sum + Math.round(Math.round(item.product.price * 100) * item.quantity / (1 + standardVatRate)), 0);
  return { inclusivePence, exclusivePence, vatPence: inclusivePence-exclusivePence };
}
function nativeCartLinePriceMarkup(item) {
  const product = [...csTheme.products, ...csTheme.addons, csTheme.currentProduct].find(product => product && String(product.variantId) === String(item.variant_id));
  const comparePence = isOnSale(product) ? Math.round(product.comparePrice * 100) * item.quantity : 0;
  return productPriceMarkup({ price: item.final_line_price / 100, comparePrice: Math.max(item.original_line_price || item.final_line_price, comparePence) / 100 });
}
function renderNativeDrawer() {
  const container = $('#basket-content');
  if (!container || !nativeCart) return;
  if (!nativeCart.items.length) {
    container.innerHTML = `<p class="basket-empty">Your cart is empty.</p><a class="button" href="${escapeHtml(csTheme.collectionUrl)}">Explore HorizonLite →</a>`;
    return;
  }
  const rows = nativeCart.items.map(item => {
    const image = item.featured_image?.url || item.image || themeAsset('horizonlite-product.jpg');
    return `<article class="basket-item"><img src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title)}" width="76" height="76"><div><h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}<p>${nativeCartLinePriceMarkup(item)}</p><div class="basket-item-controls"><div><button type="button" data-native-line="${escapeHtml(item.key)}" data-native-quantity="${Math.max(0,item.quantity-1)}" aria-label="Reduce quantity of ${escapeHtml(item.product_title)}">−</button><span>${item.quantity}</span><button type="button" data-native-line="${escapeHtml(item.key)}" data-native-quantity="${item.quantity+1}" aria-label="Increase quantity of ${escapeHtml(item.product_title)}">+</button></div><button type="button" data-native-line="${escapeHtml(item.key)}" data-native-quantity="0">Remove</button></div></div></article>`;
  }).join('');
  container.innerHTML = `${rows}<div class="basket-total"><span>Subtotal</span><strong>${priceMarkup(nativeCart.total_price/100)}</strong></div><p class="basket-note">Delivery and any applicable discounts are confirmed at checkout.</p><p id="drawer-cart-status" class="cs-cart-status" role="status"></p><a class="button" href="${escapeHtml(csTheme.cartUrl)}">View cart <span aria-hidden="true">→</span></a><button type="button" class="text-link basket-continue" data-basket-close>Continue exploring ←</button>`;
}
document.addEventListener('click', async event => {
  if (event.target.closest('[data-basket-close]')) { $('#basket-dialog')?.close(); return; }
  const button = event.target.closest('[data-native-line]');
  if (!button) return;
  const key = button.dataset.nativeLine, quantity = Number(button.dataset.nativeQuantity);
  const controls = $$('[data-native-line]');
  controls.forEach(control => { control.disabled = true; });
  try { await changeNativeCartItem(key, quantity); renderNativeDrawer(); }
  catch (error) { if ($('#drawer-cart-status')) $('#drawer-cart-status').textContent = error.message; }
  finally { controls.forEach(control => { control.disabled = false; }); }
});
refreshNativeCart().catch(() => { /* Native forms and cart links remain available. */ });



function rooflightForSize(value) {
  const key = parseSizeKey(value);
  return products.find(product => sizeKey(product) === key);
}

function matchesRoofOpening(product, value) {
  return !value || sizeKey(product) === parseSizeKey(value);
}

function fillSizeOptions(select, selectedValue = '', allLabel = '') {
  const selected = parseSizeKey(selectedValue);
  select.innerHTML = (allLabel ? `<option value="">${allLabel}</option>` : '') + products.map(product => `<option value="${sizeKey(product)}">${sizeLabel(product)}</option>`).join('');
  select.value = products.some(product => sizeKey(product) === selected) ? selected : allLabel ? '' : sizeKey(products[0]);
  select.disabled = false;
}

function orientationExplanation(product) {
  if (product.width === product.length) return `${sizeLabel(product)} is the internal size and roof opening. This square rooflight can be fitted either way round.`;
  const reversedSize = sizeKey(product).split('x').reverse().join(' × ') + ' mm';
  return `Fit in portrait or landscape. ${sizeLabel(product)} and ${reversedSize} are the same rooflight.`;
}

const contactWidget = $('.contact-widget');
const contactPanel = $('#contact-panel');
const contactLauncher = $('.contact-launcher');
function toggleContactPanel(open, restoreFocus = false) {
  if (!contactPanel || !contactLauncher) return;
  contactPanel.hidden = !open;
  contactLauncher.setAttribute('aria-expanded', String(open));
  if (open) {
    toggleMenu(false);
    $('a', contactPanel)?.focus({ preventScroll: true });
  } else if (restoreFocus) contactLauncher.focus({ preventScroll: true });
}
contactLauncher?.addEventListener('click', () => toggleContactPanel(contactPanel.hidden));
$('[data-contact-close]')?.addEventListener('click', () => toggleContactPanel(false, true));
$$('.contact-option').forEach(link => link.addEventListener('click', () => toggleContactPanel(false)));
document.addEventListener('pointerdown', event => {
  if (contactPanel && !contactPanel.hidden && !contactWidget.contains(event.target)) toggleContactPanel(false);
});
document.addEventListener('focusin', event => {
  if (contactPanel && !contactPanel.hidden && !contactWidget.contains(event.target)) toggleContactPanel(false);
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && contactPanel && !contactPanel.hidden) toggleContactPanel(false, true);
});
const mobileOrderBar = $('.pdp-mobile-order');
if (contactWidget && mobileOrderBar && 'ResizeObserver' in window) {
  new ResizeObserver(() => {
    contactWidget.style.setProperty('--contact-order-height', `${mobileOrderBar.getBoundingClientRect().height}px`);
  }).observe(mobileOrderBar);
}

function closeDialog(dialog) { dialog.close(); }
function openDialog(dialog) {
  toggleContactPanel(false);
  $$('dialog[open]').forEach(closeDialog);
  dialog.showModal();
  dialog.scrollTop = 0;
}
$$('dialog').forEach(dialog => {
  $('.dialog-close', dialog).addEventListener('click', () => closeDialog(dialog));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
  });
});

const menuButton = $('.menu-toggle');
function toggleMenu(open, restoreFocus = false) {
  if (!menuButton || !$('#mobile-menu')) return;
  if (open) toggleContactPanel(false);
  menuButton.setAttribute('aria-expanded', String(open));
  menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  $('#mobile-menu').hidden = !open;
  if (!open && restoreFocus) menuButton.focus();
}
menuButton?.addEventListener('click', () => toggleMenu(menuButton.getAttribute('aria-expanded') !== 'true'));
$('#mobile-menu-close')?.addEventListener('click', () => toggleMenu(false, true));
$$('#mobile-menu a').forEach(link => link.addEventListener('click', () => toggleMenu(false)));
document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && menuButton?.getAttribute('aria-expanded') === 'true') toggleMenu(false, true);
});
window.matchMedia('(min-width:1181px)').addEventListener('change', event => { if (event.matches) toggleMenu(false); });

$$('[data-filter]').forEach(button => button.addEventListener('click', () => {
  const filter = button.dataset.filter;
  $$('[data-filter]').forEach(other => {
    const active = other === button;
    other.classList.toggle('active', active);
    other.setAttribute('aria-pressed', String(active));
  });
  let count = 0;
  $$('.project-card').forEach(card => {
    card.hidden = filter !== 'all' && card.dataset.category !== filter;
    if (!card.hidden) count++;
  });
  $('#project-count').textContent = `${count} featured ${count === 1 ? 'project' : 'projects'}`;
}));

function projectArticleUrl(key) { return projects[key]?.url || '/blogs/case-studies'; }

function openProject(key) {
  const project = projects[key];
  if (!project) return;
  const sizes = project.sizes || [[project.productWidth, project.productLength]];
  const matchingProducts = sizes.map(size => rooflightForSize(size.join('x'))).filter(Boolean);
  const matchingProduct = matchingProducts[0];
  const additionalSizes = matchingProducts.slice(1).map(p => `<a class="project-size-link" href="${rooflightUrl(p)}">View ${p.width} × ${p.length} mm <svg class="ui-arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 18 18 6M6 6h12v12"/></svg></a>`).join('');
  $('#project-dialog-content').innerHTML = `<img class="project-dialog-image" ${responsiveImageAttributes(project.image, "(max-width: 700px) 100vw, 900px")} alt="${escapeHtml(project.imageAlt || project.title)}"><div class="project-dialog-body"><p class="eyebrow">${escapeHtml(project.category)}</p><h2 id="project-dialog-title">${escapeHtml(project.title)}</h2><p class="project-credit">${escapeHtml(project.credit)}</p><div class="project-story"><div>${project.paragraphs.map(p => `<p>${escapeHtml(p)}</p>`).join('')}</div><aside class="project-facts" aria-label="Project details"><dl>${project.details.map(([term, value]) => `<dt>${escapeHtml(/^(?:rooflight )?sizes?$/i.test(term) ? 'Internal size / roof opening' : term)}</dt><dd>${escapeHtml(value)}</dd>`).join('')}</dl></aside></div><div class="project-dialog-actions">${matchingProduct ? `<button type="button" class="button" data-product="${matchingProduct.id}">Explore ${sizeLabel(matchingProduct)} <span aria-hidden="true"><svg class="ui-arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 18 18 6M6 6h12v12"/></svg></span></button>` : `<button type="button" class="button" data-to-range>Explore HorizonLite <span aria-hidden="true"><svg class="ui-arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 18 18 6M6 6h12v12"/></svg></span></button>`}${additionalSizes}<a class="text-link" href="${projectArticleUrl(key)}">Read full project <span aria-hidden="true"><svg class="ui-arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 18 18 6M6 6h12v12"/></svg></span></a></div></div>`;
  openDialog($('#project-dialog'));
}

function renderProducts() {
  const size = $('#size-filter').value;
  const sort = $('#product-sort').value;
  let matches = products.filter(p => matchesRoofOpening(p, size));
  if (sort === 'price-low') matches.sort((a, b) => a.price - b.price);
  if (sort === 'price-high') matches.sort((a, b) => b.price - a.price);
  let visible = matches;
  const featuredKeys = ['600x900', '800x1200', '1000x1200', '1000x2000'];
  if (!expanded && !size && sort === 'size') visible = featuredKeys.map(key => matches.find(p => sizeKey(p) === key)).filter(Boolean);
  else if (!expanded && !size) visible = matches.slice(0, 4);
  $('#product-count').textContent = size ? `${matches.length} ${matches.length === 1 ? 'size matches' : 'sizes match'} your roof opening` : `${visible.length} of ${products.length} standard sizes`;
  $('#product-grid').innerHTML = visible.length ? visible.map(p => `<article class="product-card"><button type="button" data-product="${p.id}" aria-label="View HorizonLite ${sizeLabel(p)} internal size and roof opening"><img ${responsiveImageAttributes("horizonlite-product.jpg", "(max-width: 640px) calc((100vw - 62px) / 2), 26vw")} width="600" height="600" loading="lazy" alt="Cambridge HorizonLite fixed frameless rooflight">${saleBadgeMarkup(p)}</button><div class="product-card-copy"><p class="card-eyebrow">CAMBRIDGE HORIZONLITE</p><h3>${p.width} × ${p.length} <span>mm</span></h3><p>Internal size / roof opening</p><div class="price-row"><span class="price">${productPriceMarkup(p)}</span><button type="button" data-product="${p.id}">View product <svg class="ui-arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 18 18 6M6 6h12v12"/></svg></button></div><p class="product-stock${stockStatus(p) === 'pre-order' ? ' is-preorder' : ''}"><i aria-hidden="true"></i><span>${stockLabel(p)}</span></p></div></article>`).join('') : `<div class="empty-products"><h3>Let’s find your size.</h3><p>There isn’t a standard size matching this roof opening. Choose another size, or <a href="/pages/contact-us" data-close-dialog>ask our team for help</a>.</p></div>`;
  $('#show-all').hidden = Boolean(size) || matches.length <= 4;
  $('#show-all').innerHTML = expanded ? 'Show featured sizes <span aria-hidden="true">↑</span>' : `Browse all ${products.length} sizes <span aria-hidden="true">→</span>`;
}

function openProduct(id) {
  const p = products.find(product => String(product.id) === String(id));
  if (!p) return;
  window.location.assign(rooflightUrl(p));
}

$('#size-filter')?.addEventListener('change', renderProducts);
$('#product-sort')?.addEventListener('change', renderProducts);
$('#size-form')?.addEventListener('submit', event => { event.preventDefault(); renderProducts(); });
$('#reset-sizes')?.addEventListener('click', () => { $('#size-filter').value = ''; $('#product-sort').value = 'size'; renderProducts(); });
$('#show-all')?.addEventListener('click', () => { expanded = !expanded; renderProducts(); if (!expanded) $('#find-size').scrollIntoView({ behavior: 'smooth' }); });

async function loadProducts() {
  try {
    const response = await fetch(themeAsset('horizonlite-dimensions.json'));
    if (!response.ok) throw new Error('Size information could not load');
    const metadata = await response.json();
    const current = csTheme.currentProduct;
    const source = [...csTheme.products];
    if (current && /HorizonLite/i.test(current.title) && !source.some(p => String(p.id) === String(current.id))) source.push(current);
    products = source.map(p => {
      const measured = metadata[String(p.id)];
      if (measured) return { ...p, ...measured };
      const size = p.title.match(/(\d+)\s*[x×]\s*(\d+)\s*mm/i);
      return size ? { ...p, width: Number(size[1]), length: Number(size[2]) } : null;
    }).filter(Boolean).sort((a,b) => a.width-b.width || a.length-b.length);
    horizonliteAddons = csTheme.addons.map(p => ({ ...p, image: p.image || themeAsset(p.key === 'percenta' ? 'percenta-coating.png' : 'structural-tape.png') }));
    if (!products.length) throw new Error('No HorizonLite sizes are configured');
    catalogueLoadState = 'ready';
    if ($('#size-form')) { fillSizeOptions($('#size-filter'), '', 'All sizes'); renderProducts(); }
    document.dispatchEvent(new CustomEvent('catalogue:loaded', { detail: products }));
  } catch {
    catalogueLoadState = 'error';
    if ($('#product-count')) $('#product-count').textContent = 'Please contact our team for help choosing a size.';
    document.dispatchEvent(new CustomEvent('catalogue:error'));
  }
}


const guides = {
  sizing: { title: 'Internal size = roof opening.', body: '<p><strong>Every HorizonLite size shown is the internal size. This is also the size of the roof opening.</strong> An 800 × 2000 mm HorizonLite fits an 800 × 2000 mm roof opening.</p><p><strong>Fits portrait or landscape.</strong> There is no fixed width or length: 800 × 2000 mm and 2000 × 800 mm are the same rooflight. Choose the size pair that matches your opening, whichever way round it runs.</p><p>The overall rooflight is larger than the opening: 100 mm on each side, adding 200 mm to each dimension. For example, the overall size of the 800 × 2000 mm rooflight is 1000 × 2200 mm.</p><ul><li>Measure the two sides of your roof opening in millimetres.</li><li>Select that pair of dimensions as your internal size / roof opening.</li><li>Share the installation guide with your installer for the upstand and fitting details.</li></ul>', action: '<button type="button" class="button" data-quote="HorizonLite advice">Ask for sizing help <svg class="ui-arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 18 18 6M6 6h12v12"/></svg></button>' },
  installation: { url: '/pages/installation-guides' },
  delivery: { url: '/pages/shipping-returns' }
};

function openGuide(key) {
  const guide = guides[key];
  if (!guide) return;
  if (guide.url) {
    const selectedSize = parseSizeKey(new URLSearchParams(window.location.search).get('size'));
    window.location.assign(guide.url + (selectedSize ? `?size=${selectedSize}` : ''));
    return;
  }
  $('#guide-dialog-content').innerHTML = `<p class="eyebrow">HORIZONLITE SIZING</p><h2 id="guide-dialog-title">${guide.title}</h2>${guide.body}${guide.action}`;
  openDialog($('#guide-dialog'));
}

function openQuote(interest, size) {
  const trade = /^trade\b/i.test(String(interest));
  const page = trade ? '/pages/trade-account' : '/pages/contact-us';
  const topics = { 'HorizonLite advice': 'horizonlite', FAKRO: 'fakro', 'Roof lantern': 'lantern' };
  const url = new URL(page, window.location.href);
  if (!trade) url.searchParams.set('topic', topics[interest] || 'horizonlite');
  const selectedSize = parseSizeKey(size);
  if (selectedSize) url.searchParams.set('size', selectedSize);
  url.hash = trade ? 'trade-application' : 'contact-form';
  window.location.assign(page + url.search + url.hash);
}

document.addEventListener('click', event => {
  const project = event.target.closest('[data-project]');
  const product = event.target.closest('[data-product]');
  const guide = event.target.closest('[data-guide]');
  const quote = event.target.closest('[data-quote]');
  if (project) openProject(project.dataset.project);
  else if (product) openProduct(product.dataset.product);
  else if (guide) openGuide(guide.dataset.guide);
  else if (quote) openQuote(quote.dataset.quote, quote.dataset.size);
  else if (event.target.closest('[data-to-range]')) { $$('dialog[open]').forEach(closeDialog); if ($('#find-size')) $('#find-size').scrollIntoView({ behavior: 'smooth' }); else window.location.assign('/collections/fixed-frameless#collection-results'); }
});

loadProducts();
/* CS-HOME-LOOX-RATINGS-START */
(function () {
  const grid = document.getElementById('product-grid');
  if (!grid || typeof csTheme === 'undefined' ||
      grid.dataset.csLooxRatings === 'ready') return;

  grid.dataset.csLooxRatings = 'ready';

  const style = document.createElement('style');
  style.textContent = `
    #product-grid .cs-home-rating {
      margin-top:12px;
      font-size:12px;
      color:var(--accent);
    }
    #product-grid .cs-home-rating .c-reviews-placeholder {
      display:inline-flex;
      align-items:center;
      flex-wrap:wrap;
      gap:4px 7px;
      font-size:inherit;
      line-height:1.6;
      color:inherit;
    }
    #product-grid .cs-home-rating .c-native-stars {
      font-size:13px;
    }
    @media (max-width:640px) {
      #product-grid .cs-home-rating {
        margin-top:10px;
        font-size:11px;
      }
      #product-grid .cs-home-rating .c-native-stars {
        font-size:12px;
      }
    }
  `;
  document.head.appendChild(style);

  function showRatings() {
    grid.querySelectorAll('.product-card').forEach(card => {
      if (card.querySelector('.cs-home-rating')) return;

      const id = card.querySelector('[data-product]')
        ?.getAttribute('data-product');

      const item = csTheme.products.find(
        product => String(product.id) === String(id)
      );

      const price = card.querySelector('.price-row');
      const rating = Number(item?.rating);
      const count = Number(item?.raters);

      if (!item || !price ||
          !Number.isFinite(rating) || rating <= 0 || rating > 5 ||
          !Number.isInteger(count) || count < 1) return;

      const badge = document.createElement('div');
      badge.className = 'cs-home-rating';
      badge.innerHTML = nativeRatingFallback(item, item.url)
  .replace(`${rating.toFixed(1)} (${count})`, `(${count})`);
      price.before(badge);
    });
  }

  new MutationObserver(showRatings).observe(grid, {
    childList:true
  });

  showRatings();
}());
/* CS-HOME-LOOX-RATINGS-END */